import React, { PropTypes } from 'react';
import ManagersList from './ManagersList';

class ManagersRoot extends React.Component {
  static propTypes = {
    children: PropTypes.node
  };
  render() {
    let { children } = this.props;

    return (
      <div>
        <ManagersList/>
        {children}
      </div>
    );
  }
}

export default ManagersRoot;




// WEBPACK FOOTER //
// ./src/components/Managers/ManagersRoot.jsx